import { faIcon } from "@utils/faIcon"

import { EmptyState } from "@molecules"

import styles from "@organisms/ObjectsView/CardsView/CardsViewEdgeStates/CardsViewEdgeStates.module.scss"
import CardsViewSkeletonCard from "@organisms/ObjectsView/CardsView/CardsViewEdgeStates/CardsViewSkeletonCard/CardsViewSkeletonCard"
import useObjectsView from "@organisms/ObjectsView/ObjectsView.context"

export default function CardsViewErrorState() {
    const { refetch } = useObjectsView()

    return (
        <div className={styles.base}>
            <div className={styles.graphic}>
                <div className={styles.graphicCard}>
                    <CardsViewSkeletonCard />
                </div>
            </div>
            <EmptyState
                variant="error"
                icon={faIcon({ name: "circle-xmark", style: "solid" })}
                title="Hmm, something went wrong"
                supportText="An error occurred while fetching data."
                primaryCTA={{
                    children: "Reload",
                    leftIcon: faIcon({ name: "refresh", style: "regular" }),
                    onClick: () => void refetch(),
                }}
            />
        </div>
    )
}
